export const Loading = () => (
	<span className="relative pr-3">
		Loading&nbsp;<span className="absolute dot-loading-animation"></span>
	</span>
)
